import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';
import { getOrigin } from '../getOrigin';

export const fetchCurrentsong = async ({
  url,
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    url: `${getOrigin(url)}/currentsong`,
    parser: async (response) => {
      if (!response.headers.get('Content-Type')?.includes('text/plain')) {
        return;
      }

      return response.text();
    }
  });
};
